// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-modal{padding:2rem;max-width:32rem}.alert-modal h2{font-size:1.2rem;margin-bottom:1rem}.alert-modal p{font-size:1rem;margin:0}\n", ""]);
// Exports
module.exports = exports;
